import React, { useEffect, useState } from "react";
import BackToGameList from "../../utils/BackToGameList";
import Card from "react-bootstrap/esm/Card";
import PreStart from "./PreStart";
import PickNewGame from "./PickNewGame";
import toast, { Toaster } from "react-hot-toast";

function PickNew() {
  const [start, setStart] = useState(false);
  const [count, setCount] = useState(0);
  const [incorrectCount, setIncorrectCount] = useState(0);
  const [number, setNumber] = useState(0);

  useEffect(() => {
    if (count > 0) {
      if (count === number) {
        toast("Congratulations you've selected the new item 15 times!", {
          duration: 5000,
          position: "right",
        });
        setStart(false);
        setCount(0);
      }
    }
  }, [count]);

  return (
    <>
      <BackToGameList />
      <div
        className="main-content"
        style={{ margin: "20px", background: "rgb(240, 244, 249)" }}
      >
        <Card bg="light" style={{ marginTop: "50px" }}>
          <Card.Header>
            <h2>Pick New</h2>
          </Card.Header>
          <Card.Body>
            {start ? (
              <>
                <div>
                  Score: {count} / {number} | Number of times incorrect:{" "}
                  {incorrectCount}
                </div>
                <PickNewGame
                  setCount={setCount}
                  setNumber={setNumber}
                  setIncorrectCount={setIncorrectCount}
                />
              </>
            ) : (
              <PreStart setStart={setStart} />
            )}
          </Card.Body>
        </Card>
      </div>
    </>
  );
}

export default PickNew;
